// extracted by mini-css-extract-plugin
export default {"generatePdfButton":"GenerateAccountStatementButton_generatePdfButton__IkLoJ"};